export default "__VITE_ASSET__1$o7SpC0__"